import { ToolButton } from '@crabs-ai/ds-react';
import { Redo } from '@crabs-ai/web-icons';
import React, { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import {
  useCanUseUndoStack,
  useWriteContext,
} from '@/features/remotion-editor/editor/utils/use-context';

export default function EditorHeaderRedoButton() {
  const t = useTranslations();
  const { redo } = useWriteContext();
  const { canRedo } = useCanUseUndoStack();

  const handleRedo = useCallback(() => {
    redo();
  }, [redo]);

  return (
    <ToolButton
      size="sm"
      isTransparent={false}
      state={canRedo ? 'default' : 'disabled'}
      isShowTooltip={true}
      onClick={handleRedo}
      tooltipNode={t('Editor.header.redo')}
      tooltipSubNode="[⌘/Ctrl + Shift + Z]"
    >
      <Redo />
    </ToolButton>
  );
}
